///////////////////
//
///////////////////
import {
    Component,
    OnInit,
    Optional,
    Input,
    ViewChild,
    ElementRef,
    HostListener,
    Injector,
} from "@angular/core";

import { AuthenticationService } from "../../../core/auth/authentication.service";
import { Router } from "@angular/router";
import { CustomAuthorizationService } from "../../../core/auth/custom-authorization.service";
import { KeepAliveService } from "../../../core/auth/keep-alive.service";
import { ScreenSizeService } from "../../services/screen-size.service";

@Component({
    selector: "djiv-header-panel",
    templateUrl: "./djiv-header-panel.component.html",
    styleUrls: ["./djiv-header-panel.component.css"],
})
export class DJIVHeaderPanelComponent implements OnInit {
    @Input() parent: any;
    @ViewChild("djivApplicationMenu") applicationMenu: ElementRef;

    public hasAuthProviders: boolean;
    public showSignOut = false;
    public isMobile: boolean = false;
    private canShowSignOut = false;
    protected supplierName: string = "";
    private router: Router;
    private screenHeight: number = window.innerHeight;
    private screenWidth: number = window.innerWidth;
    private screenSizeService: ScreenSizeService;

    public $navigationData = [];
    public $allNavigationData = [];

    /* The keep alive service is needed in order to prevent the session on the PASOE instance
    from timing out. This is really only needed in one place, and since the header panel is 
    shown throughout the application this is a good place for it. */
    constructor(
        private authenticationService: AuthenticationService,
        router: Router,
        protected customAuthorizationService: CustomAuthorizationService,
        protected keepAliveService: KeepAliveService,
        public injector: Injector
    ) {
        this.screenSizeService = injector.get(ScreenSizeService);
        this.hasAuthProviders = this.authenticationService.requireSignIn;
        this.showSignOut = false;
        this.supplierName = sessionStorage.getItem("SupplierApp.supplierName");
        this.router = router;

        Promise.all([
            this.customAuthorizationService.processAuthorizationResponse(),
        ]).then(() => {
            this.addNavigationData();
        });
    }

    private addNavigationData() {
        if (this.customAuthorizationService.showBookings === true) {
            this.$navigationData.push({
                title: "Booking",
                titleKey: "modules.Booking.label",
                thumbnail: {
                    background: "#1d75eb",
                    color: "#1c4284",
                    icon: "fa-pie-chart",
                },
                children: [
                    {
                        title: "SupplierData",
                        titleKey: "modules.Booking.views.SupplierData.label",
                        label: "Supplier Data",
                        routerLink: "/booking/supplier-data",
                        authorization: {
                            allowedRoles: [],
                        },
                    },
                ],
            });
            this.$allNavigationData.push(
                this.$navigationData[this.$navigationData.length - 1]
            );
        }

        if (this.customAuthorizationService.showGroupBooking === true) {
            this.$navigationData.push({
                title: "Group Booking",
                titleKey: "modules.GroupBooking.label",
                thumbnail: {
                    background: "#1d75eb",
                    color: "#1c4284",
                    icon: "fa-drivers-license-o",
                },
                children: [
                    {
                        title: "Group Booking Data",
                        titleKey:
                            "modules.GroupBooking.views.SupplierData.label",
                        label: "Group Booking Data",
                        routerLink: "/group-booking/supplier-data",
                        authorization: {
                            allowedRoles: [],
                        },
                    },
                ],
            });
            this.$allNavigationData.push(
                this.$navigationData[this.$navigationData.length - 1]
            );
        }

        if (this.customAuthorizationService.showServiceLine === true) {
            this.$navigationData.push({
                title: "Service Lines",
                titleKey: "modules.ServiceLine.label",
                thumbnail: {
                    background: "#1d75eb",
                    color: "#1c4284",
                    icon: "fa-bus",
                },
                children: [
                    {
                        title: "ServiceLine",
                        titleKey: "modules.ServiceLine.views.ServiceLine.label",
                        label: "Service Line",
                        routerLink: "/service-line/service-line",
                        authorization: {
                            allowedRoles: [],
                        },
                    },
                ],
            });
            this.$allNavigationData.push(
                this.$navigationData[this.$navigationData.length - 1]
            );
        }

        if (this.customAuthorizationService.showServices === true) {
            this.$navigationData.push({
                title: "Group Services",
                titleKey: "modules.GroupService.label",
                thumbnail: {
                    background: "#1d75eb",
                    color: "#1c4284",
                    icon: "fa-cutlery",
                },
                children: [
                    {
                        title: "GroupService",
                        titleKey:
                            "modules.GroupService.views.GroupService.label",
                        label: "Group Services",
                        routerLink: "/group-service/services",
                        authorization: {
                            allowedRoles: [],
                        },
                    },
                ],
            });
            this.$allNavigationData.push(
                this.$navigationData[this.$navigationData.length - 1]
            );
        }

        if (this.customAuthorizationService.showShuttleService === true) {
            this.$navigationData.push({
                title: "Shuttle Service",
                titleKey: "modules.ShuttleService.label",
                thumbnail: {
                    background: "#1d75eb",
                    color: "#1c4284",
                    icon: "fa-bus",
                },
                children: [
                    {
                        title: "Shuttle Service",
                        titleKey:
                            "modules.ShuttleService.views.ShuttleService.label",
                        label: "Shuttle Service",
                        routerLink: "/shuttle-service/shuttle-service",
                        authorization: {
                            allowedRoles: [],
                        },
                    },
                ],
            });
            this.$allNavigationData.push(
                this.$navigationData[this.$navigationData.length - 1]
            );
        }
        if (this.customAuthorizationService.showHistoricalBookings === true) {
            this.$allNavigationData.push({
                title: "HistoricalBookings",
                titleKey: "modules.HistoricalBookings.label",
                thumbnail: {
                    background: "#1d75eb",
                    color: "#1c4284",
                    icon: "fa-pie-chart",
                },
                children: [
                    {
                        title: "SupplierData",
                        titleKey:
                            "modules.HistoricalBookings.views.SupplierData.label",
                        label: "Supplier Data",
                        routerLink: "/historical-bookings/supplier-data",
                        authorization: {
                            allowedRoles: [],
                        },
                    },
                ],
            });
        }
        if (this.$navigationData.length < 4) {
            if (
                this.customAuthorizationService.showHistoricalBookings === true
            ) {
                this.$navigationData.push({
                    title: "HistoricalBookings",
                    titleKey: "modules.HistoricalBookings.label",
                    thumbnail: {
                        background: "#1d75eb",
                        color: "#1c4284",
                        icon: "fa-pie-chart",
                    },
                    children: [
                        {
                            title: "SupplierData",
                            titleKey:
                                "modules.HistoricalBookings.views.SupplierData.label",
                            label: "Supplier Data",
                            routerLink: "/historical-bookings/supplier-data",
                            authorization: {
                                allowedRoles: [],
                            },
                        },
                    ],
                });
            }
        }
        if (this.customAuthorizationService.showContactInfo === true) {
            this.$allNavigationData.push({
                title: "Contact",
                titleKey: "modules.Contact.label",
                thumbnail: {
                    background: "#1d75eb",
                    color: "#1c4284",
                    icon: "fa-drivers-license-o",
                },
                children: [
                    {
                        title: "ContactInfo",
                        titleKey: "modules.Contact.views.ContactInfo.label",
                        label: "Contact Info",
                        routerLink: "/contact/contact-info",
                        authorization: {
                            allowedRoles: [],
                        },
                    },
                ],
            });
        }
        if (this.$navigationData.length < 4) {
            if (this.customAuthorizationService.showContactInfo === true) {
                this.$navigationData.push({
                    title: "Contact",
                    titleKey: "modules.Contact.label",
                    thumbnail: {
                        background: "#1d75eb",
                        color: "#1c4284",
                        icon: "fa-drivers-license-o",
                    },
                    children: [
                        {
                            title: "ContactInfo",
                            titleKey: "modules.Contact.views.ContactInfo.label",
                            label: "Contact Info",
                            routerLink: "/contact/contact-info",
                            authorization: {
                                allowedRoles: [],
                            },
                        },
                    ],
                });
            }
        }
        if (this.customAuthorizationService.showExchangePoint === true) {
            this.$allNavigationData.push({
                title: "ExchangePoint",
                titleKey: "modules.ExchangePoint.label",
                thumbnail: {
                    background: "#1d75eb",
                    color: "#1c4284",
                    icon: "fa-coffee",
                },
                children: [
                    {
                        title: "ExchangePoint",
                        titleKey:
                            "modules.ExchangePoint.views.SupplierData.label",
                        label: "ExchangePoint",
                        routerLink: "/exchange-point/supplier-data",
                        authorization: {
                            allowedRoles: [],
                        },
                    },
                ],
            });
        }
        if (this.$navigationData.length < 4) {
            if (this.customAuthorizationService.showExchangePoint === true) {
                this.$navigationData.push({
                    title: "ExchangePoint",
                    titleKey: "modules.ExchangePoint.label",
                    thumbnail: {
                        background: "#1d75eb",
                        color: "#1c4284",
                        icon: "fa-coffee",
                    },
                    children: [
                        {
                            title: "ExchangePoint",
                            titleKey:
                                "modules.ExchangePoint.views.SupplierData.label",
                            label: "ExchangePoint",
                            routerLink: "/exchange-point/supplier-data",
                            authorization: {
                                allowedRoles: [],
                            },
                        },
                    ],
                });
            }
        }
        if (this.customAuthorizationService.showGuidedTours === true) {
            this.$allNavigationData.push({
                title: "GuidedTours",
                titleKey: "modules.GuidedTours.label",
                thumbnail: {
                    background: "#1d75eb",
                    color: "#1c4284",
                    icon: "fa-pie-chart",
                },
                children: [
                    {
                        title: "SupplierData",
                        titleKey:
                            "modules.GuidedTours.views.SupplierData.label",
                        label: "Supplier Data",
                        routerLink: "/guided-tours",
                        authorization: {
                            allowedRoles: [],
                        },
                    },
                ],
            });
        }
        if (this.$navigationData.length < 4) {
            if (this.customAuthorizationService.showGuidedTours === true) {
                this.$navigationData.push({
                    title: "GuidedTours",
                    titleKey: "modules.GuidedTours.label",
                    thumbnail: {
                        background: "#1d75eb",
                        color: "#1c4284",
                        icon: "fa-pie-chart",
                    },
                    children: [
                        {
                            title: "SupplierData",
                            titleKey:
                                "modules.GuidedTours.views.SupplierData.label",
                            label: "Supplier Data",
                            routerLink: "/guided-tours",
                            authorization: {
                                allowedRoles: [],
                            },
                        },
                    ],
                });
            }
        }
    }

    public bookingPage() {
        this.router.navigate(["/booking/supplier-data"]);
    }

    public initialPage(): void {
        this.router.navigate(["/"]);
    }

    public toggleSignOut() {
        if (this.canShowSignOut) {
            this.showSignOut = !this.showSignOut;
        }
    }

    public signOut() {
        sessionStorage.removeItem("SupplierApp.autologin");
        sessionStorage.removeItem("SupplierApp.supplierName");
        this.authenticationService.signOut();
    }

    public toggleApplicationMenu() {
        this.applicationMenu.nativeElement.classList.toggle("showMenu");
    }

    @HostListener("window:resize", ["$event"])
    onResize(event?) {
        this.screenHeight = window.innerHeight;
        this.screenWidth = window.innerWidth;
    }

    public useSmallMenu(): boolean {
        return (
            this.screenWidth < 1100 ||
            (this.screenWidth < 1230 && this.$navigationData.length > 3)
        );
    }
    ngOnInit() {
        this.isMobile = this.screenSizeService.isMobile;
        this.screenSizeService.isMobile$.subscribe(
            (response) => (this.isMobile = response)
        );

        this.authenticationService
            .isAuthenticated()
            .subscribe((isAuthenticated) => {
                this.canShowSignOut = isAuthenticated;
            });
    }
}



// WEBPACK FOOTER //
// C:/Repositories/wfa3/SupplierPortal/app/src/app/shared/components/djiv-header-panel/djiv-header-panel.component.ts